import { Link } from '@mui/icons-material'
import { Button } from '@mui/material'
import { RosterType } from '__generated__/graphql'
import React from 'react'
import RosterDrawer from 'recruiter/components/RosterDrawer'
import { useCandidateSqlSearch } from 'recruiter/hooks'
import { wrapCandidateFilterState } from 'shared/utils/mappingFilterConverter'

export interface SaveMappingProps {
    onClick?: () => void
    isDisabled?: boolean
}

const SaveMapping: React.FC<SaveMappingProps> = ({
    isDisabled = false,
    onClick,
}) => {
    const [openDrawerType, setOpenDrawerType] = React.useState<
        'new' | undefined
    >(undefined)
    const handleClick = () => {
        if (onClick) {
            onClick()
            return
        }
        setOpenDrawerType('new')
    }
    const { tableState, hasActiveFilters } = useCandidateSqlSearch()

    // Check if there are any active filters
    const hasFilters = hasActiveFilters

    return (
        <>
            <Button
                variant="outlined"
                size="small"
                onClick={handleClick}
                disabled={isDisabled || !hasFilters}
                sx={{
                    textTransform: 'uppercase',
                    fontSize: '0.75rem',
                    fontWeight: 500,
                    py: 0.5,
                    px: 1.5,
                    borderColor: 'divider',
                    color: 'text.secondary',
                    '&:hover': {
                        borderColor: 'text.secondary',
                        bgcolor: 'action.hover',
                    },
                    '&.Mui-disabled': {
                        borderColor: 'divider',
                        color: 'text.disabled',
                    },
                }}
            >
                <Link sx={{ fontSize: '1rem', mr: 0.75 }} />
                Save Mapping
            </Button>
            <RosterDrawer
                selectedCandidates={[]}
                mappingFilter={
                    hasFilters
                        ? wrapCandidateFilterState(tableState.filters)
                        : undefined
                }
                type={openDrawerType}
                presetRosterType={RosterType.Mapping}
                onClose={() => setOpenDrawerType(undefined)}
            />
        </>
    )
}

export default SaveMapping
